var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page p-calendar"},[_c('the-dashboard-heading',[_c('h2',[_vm._v("Kalendarz")])]),_vm._v(" "),_c('the-dashboard-content',{staticClass:"p-calendar__content"},[_c('calendar-main',{staticClass:"p-calendar__calendar"})],1),_vm._v(" "),_c('v-calendar-legend')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }